const constants = {
  theme: {
    consultation: 'Консультация',
    proposal: 'Заявка',
    complaint: 'Жалоба',
    problem: 'Проблема',
  },
};

export default constants;
